import axios from '../../utils/http/axios-local'
import parseTransactions from './parse-transactions'

const fetchTransactions = async (params = {}) => {
  const transactions = await axios.get('/api/transactions', { params })
  return parseTransactions(transactions)
}
export default fetchTransactions
